import { createApi } from '@reduxjs/toolkit/query/react'
import { PORTAL } from 'constants/global'
import { apiBaseQuery } from 'prace-common-components'

export const clientApi = createApi({
  reducerPath: 'api',
  baseQuery: apiBaseQuery(PORTAL, PRACE_API_URL),
  tagTypes: ['Centers', 'Reviewers', 'CallDocuments', 'PartitionTypes', 'ImpersonationActions'],
  endpoints: () => ({}),
})
